// R&D Raw Material 采购申请表 （生产性物料）

import { Form } from "antd";
import { ApplicationInfoFormFields } from "./ApplicationInfoFormFields";
import { SpecialRequirementFormFields } from "./SpecialRequirementFormFields";
import { UserFormFields } from "@/components/UserFormFields/UserFormFields";
import type { PurchaseRequestFormProps } from "../../type";
import { usePurchaseRequestDetail } from "../../hooks/usePurchaseRequest";
import { useModal } from "@/hooks/modals/useModal";
import { useFormEditable } from "../../hooks/useFormEditable";
import { SupplierInfoFormFields } from "./SupplierInfoFormFields";
import { OrderConfrimFormFields } from "../OrderConfrimFormFields";
import { useExistFlowHistory } from "@/hooks/services/useFlow";
import {
  fillInPONodeCodes,
  purchaseManagerAuditNodeCodesForRD,
} from "../../constant";
import { useTranslation } from "react-i18next";

export const RdRawMaterialRequisitionForm = ({
  form,
}: PurchaseRequestFormProps) => {
  const { t } = useTranslation("purchaseRequestManagement");
  const { props } = useModal("PURCHASE_REQUEST");
  const { recordId } = props;

  const detail = usePurchaseRequestDetail(recordId);
  const { isMainFormDisabled } = useFormEditable();

  const shouldShowSupplierInfo = useExistFlowHistory(
    purchaseManagerAuditNodeCodesForRD,
    detail?.insId,
  );

  const shouldShowOrderConfirm = useExistFlowHistory(
    fillInPONodeCodes,
    detail?.insId,
  );

  return (
    <Form layout="vertical" disabled={isMainFormDisabled} form={form}>
      <UserFormFields />
      {/* 申请信息 */}
      <ApplicationInfoFormFields />
      {/* 特别要求 */}
      <SpecialRequirementFormFields />
      {/* 供应商信息 */}
      {shouldShowSupplierInfo && <SupplierInfoFormFields />}
      {/* 订单确认 */}
      {shouldShowOrderConfirm && <OrderConfrimFormFields />}
    </Form>
  );
};
